import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '@app/material.module';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NoAuthComponent } from './pages/no-auth.component';
import { LoginComponent } from '../account/pages/login/login.component';
import { ResetPassComponent } from '../account/pages/reset/resetpass.component';

@NgModule({
  declarations: [NoAuthComponent, LoginComponent, ResetPassComponent],
  imports: [CommonModule, BrowserAnimationsModule, MaterialModule, SharedModule, RouterModule],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NoAuthModule {}
